import { Dropdown, DropdownSize, Icon, IconName, Text } from '@billy/design-system'
import { Badge } from '@shinetools/lumen-react'
import { ReactElement, ReactNode } from 'react'

import { SuppliersBalanceFilterType } from '../../../enums/suppliersBalanceFilterType'
import { FilterChipFooter } from './FilterChipFooter'
import { ChipTrigger, PopoverBody, PopoverCard, ValuePreview } from './styles'

export interface FilterChipShellProps {
  type: SuppliersBalanceFilterType
  icon: IconName
  label: string
  valuePreview?: string
  valueCount?: number
  isActive: boolean
  dropdownSize?: DropdownSize
  onDelete: () => void
  onReset: () => void
  onOpen?: () => void
  onClose?: () => void
  children: ReactNode
}

export const FilterChipShell = ({
  type,
  icon,
  label,
  valuePreview,
  valueCount,
  isActive,
  dropdownSize = 'xxxl',
  onDelete,
  onReset,
  onOpen,
  onClose,
  children,
}: FilterChipShellProps): ReactElement => {
  return (
    <Dropdown
      size={dropdownSize}
      placement="bottom-start"
      onOpen={onOpen}
      onClose={onClose}
      trigger={
        <ChipTrigger type="button" isActive={isActive} data-filter-type={type}>
          <Icon icon={icon} />
          <Text weight="medium">{label}</Text>
          {valuePreview ? <ValuePreview>{valuePreview}</ValuePreview> : null}
          {valueCount !== undefined ? (
            <Badge color="accent" count={valueCount} data-testid="filter-chip-count" />
          ) : null}
          <Icon icon="chevronDown" />
        </ChipTrigger>
      }
    >
      <PopoverCard>
        <PopoverBody>{children}</PopoverBody>
        <FilterChipFooter onDelete={onDelete} onReset={onReset} />
      </PopoverCard>
    </Dropdown>
  )
}
